import Http from 'axios'
import {API_URL, VERSION, VERSIONED_API_URL} from '../../config/config'

function initialState() {
    return {
        trekkingData: {
            trekkingAgency: {},
            trekkingRoute: {
                min_days: "0"
            },
            trekkers: [{
                traveller: {
                    currentDocument: {}
                },
                visa_number: "",
            }, {
                traveller: {
                    currentDocument: {}
                },
                visa_number: "",
            }],
            extra: {
                nepaliGuide: {}
            },
            voucher_number: null,
            paid: false,
            status: "",

        },
        loading: false,
        rejectModal: false,
        approveModal: false,
        permitPdfUrl: null,
        trekkingAgencylist: [],
        trekkingRoutesList: [],
        acknowledgePenaltyModal: false,
        tippaniVerificationModel: false,
        forwardPurpose: null,
        assignedTrekkingRequests: [],
    }
}

const getters = {
    loading: state => state.loading,
    trekkingData: state => state.trekkingData,
    rejectModal: state => state.rejectModal,
    approveModal: state => state.approveModal,
    trekkingAgencylist: state => state.trekkingAgencylist,
    trekkingRouteslist: state => state.trekkingRoutesList,
    assignedTrekkingRequests: state => state.assignedTrekkingRequests
};

const actions = {
    getTrekkingAgencyList({
                              commit,
                              state
                          }) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/trekking-agencies/fetch-all')
                .then(response => {
                    commit('setLoading', false)
                    commit('setTrekkingAgencylist', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    getAllTrekkingRoutesList({
                                 commit,
                                 state
                             }) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/trekking-routes/fetch-all')
                .then(response => {
                    commit('setLoading', false)
                    commit('setTrekkingRouteslist', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    getTrekkingRequestDetail({
                                 commit,
                                 state
                             }, id) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/trekking-requests/get/' + id)
                .then(response => {
                    commit('setLoading', false)
                    commit('setTrekkinData', response.data.data)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    getSingleTrekkingRequestDetail({
                                       commit,
                                       state
                                   }, id) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/trekking-requests/single/get/' + id)
                .then(response => {
                    commit('setLoading', false)
                    commit('setTrekkinData', response.data.data)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    createTrekkingRequest({
                              commit,
                              state
                          }) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekking-requests/save', state.trekkingData)
                .then(response => {
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    verifyTrekkingRequest({state, commit}) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekking-requests/verify/' + state.trekkingData.id)
                .then(response => {
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    verifySingleTrekkingRequest({state, commit}) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekking-requests/single/verify/' + state.trekkingData.id)
                .then(response => {
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    generateVoucherNumber({state, commit, dispatch}) {
        commit('setLoading', true);
        return new Promise(((resolve, reject) => {
            Http.put(API_URL + VERSION + '/trekking-requests/generate-voucher/' + state.trekkingData.id).then((res) => {
                dispatch('getTrekkingRequestDetail', state.trekkingData.id);
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        }));
    },
    async saveTippani({state, commit, dispatch}, data) {
        commit('setLoading', true);
        try {
            await Http.post(`${VERSIONED_API_URL}/trekking-requests/save-tippani/` + state.trekkingData.id, {
                content: data
            });
            commit('setLoading', false);
            dispatch('getTrekkingRequestDetail', state.trekkingData.id);

        } catch (e) {
            commit('setLoading', false);
            throw e;
        }
    },
    async saveSingleTippani({state, commit, dispatch}, data) {
        commit('setLoading', true);
        try {
            await Http.post(`${VERSIONED_API_URL}/trekking-requests/save-tippani/` + state.trekkingData.id, {
                content: data
            })
            commit('setLoading', false);
            dispatch('getTrekkingRequestDetail', state.trekkingData.id);
        } catch (e) {
            commit('setLoading', false);
            throw e;
        }
    },
    async checkPaymentStatus({commit, state}) {
        commit('setLoading', true);
        try {
            const response = await Http.put(API_URL + VERSION + '/trekking-requests/check-payment-status/' + state.trekkingData.id);
            commit('setLoading', false);
            commit('setPaid', response.data.voucher_detail);
            return response;
        } catch (e) {
            commit('setLoading', false);
            throw e;
        }

    },
    approveRequest({
                       commit,
                       state
                   }, data) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekking-requests/approve/' + state.trekkingData.id, data)
                .then(response => {
                    commit('setTrekkinData', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    approveSingleRequest({
                             commit,
                             state
                         }, data) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekking-requests/single/approve/' + state.trekkingData.id, data)
                .then(response => {
                    commit('setTrekkinData', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    approveRequestDirector({
                               commit,
                               state
                           }, data) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekking-requests/approve/' + state.trekkingData.id + '?director=' + true, data)
                .then(response => {
                    commit('setTrekkinData', response.data.data)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },

    rejectRequest({
                      commit,
                      state
                  }, data) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekking-requests/reject/' + state.trekkingData.id, data)
                .then(response => {
                    commit('setTrekkinData', response.data.data)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    resetState({
                   commit
               }) {
        commit('resetState')
    },
    generateTrekkingStickerPrintedTrack({commit, state, dispatch}) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekking-requests/generate-print-sticker-number-track/' + state.trekkingData.id)
                .then(response => {
                    dispatch('getTrekkingRequestDetail', state.trekkingData.id);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    async forwardUser({commit, state}, data) {
        console.log('data', data);
        await Http.post(API_URL + VERSION + '/trekking-requests/forward-user/' + state.trekkingData.id, data)
    },
    verifyTippaniGenerated({commit, state, dispatch}, data) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/trekking-requests/verify-approve-tippani/verify/` + state.trekkingData.id, data).then(response => {
                this.commit('Notification/showSuccess', response.data.message);
                resolve(response)
            }).catch(error => {
                this.commit('Notification/showError', error.response.data.message);
                reject(error)
            }).finally(() => {
                commit('setLoading', false);
            })
        });
    },
    approveTippani({commit, state, dispatch}, data) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/trekking-requests/verify-approve-tippani/approve/` + state.trekkingData.id, data).then(response => {
                this.commit('Notification/showSuccess', response.data.message);
                resolve(response)
            }).catch(error => {
                this.commit('Notification/showError', error.response.data.message);
                reject(error)
            }).finally(() => {
                commit('setLoading', false);
            })
        });
    },
    getAssignedTrekkingRequests({commit, state}) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/user/assigned-trekking-requests')
                .then(response => {
                    commit('setAssignedTrekkingRequests', response.data.data);
                    resolve(response.data)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                }).finally(() => {
                commit('setLoading', false);
            })
        });
    },
    async dropForwarded({commit, state, dispatch}, data) {
        commit('setLoading', true);
        try {
            const response = await Http.post(`${API_URL}${VERSION}/trekking-requests/drop-forwarded/` + state.trekkingData.id, data);
            commit('setLoading', false);
            dispatch('getTrekkingRequestDetail', state.trekkingData.id);
            this.commit('Notification/showSuccess', response.data.message);
        } catch (e) {
            commit('setLoading', false);
            this.commit('Notification/showError', error.response.data.message);
        }
    },

    async TrekkingMarksAsCompleted({commit, state, dispatch}, data) {
        commit('setLoading', true);
        try {
            console.log(data);
            const response = await Http.post(`${API_URL}${VERSION}/trekking-requests/assignment/mark-as-completed/`, data);
            commit('setLoading', false);
            dispatch('getTrekkingRequestDetail', state.trekkingData.id);
            this.commit('Notification/showSuccess', response.data.message);
        } catch (e) {
            commit('setLoading', false);
            this.commit('Notification/showError', error.response.data.message);
        }
    },
}

const mutations = {
    setTrekkinData(state, items) {
        state.trekkingData = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setRejectModal(state, item) {
        state.rejectModal = item
    },
    setApproveModal(state, item) {
        state.approveModal = item
    },
    setPaid(state, item) {
        state.trekkingData.paid = true;
        state.trekkingData.payment_detail = item;
    },
    setPermitPdfUrl(state, item) {
        state.permitPdfUrl = item
    },
    setTrekkingAgencylist(state, item) {
        state.trekkingAgencylist = item
    },
    setTrekkingRouteslist(state, item) {
        state.trekkingRoutesList = item
    },
    setAcknowledgePenaltyModal(state, status) {
        state.acknowledgePenaltyModal = status
    },
    setTippaniVerificationModal(state, status) {
        state.tippaniVerificationModel = status
    },
    setForwardPurpose(state, item) {
        state.forwardPurpose = item
    },
    setAssignedTrekkingRequests(state, items) {
        state.assignedTrekkingRequests = items
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
